import { useEffect } from "react";

/**
 * Adds `is-in` to every `.reveal` element as it scrolls into view — the same
 * job AOS did in v1, without the dependency. Elements are revealed
 * immediately if IntersectionObserver is unavailable.
 */
export default function useReveal(deps = []) {
  useEffect(() => {
    const targets = Array.from(document.querySelectorAll(".reveal:not(.is-in)"));
    if (!targets.length) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      targets.forEach((el) => el.classList.add("is-in"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.08 }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, deps);
}
